// Ratera 4PVU/330
import React from "react";
import { CommonRows, CreelTensionRow, InputRangeRow, RunTimeRow, WindingTensionRow } from "./index";

export default function MachineRatera() {
   return (
      <>
         <InputRangeRow
            titleProp={"Clock Setting"}
            descriptionProp={"m"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={999999} //some default value
            propertyNameProp={"clockSet"}
            errorDialogueProp={"0-999,999"}
            floatProp={false}
         />
         <RunTimeRow />
         <InputRangeRow
            titleProp={"Linear Drive Setting"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0.0}
            maxProp={10.0}
            propertyNameProp={"linearSet"}
            errorDialogueProp={"0.0-10.0"}
            floatProp={true}
         />
         <CreelTensionRow />
         <WindingTensionRow windingTension />
         <CommonRows />
      </>
   );
}
